import { colors } from '../components/theme'
import { token } from '@planningcenter/tapestry'

export const Apps = [
  {
    name: 'API',
    key: 'api',
    scope: 'api',
    beta: false,
    icon: 'logomark.api',
    background: colors['api'],
  },
  {
    name: 'Calendar',
    key: 'calendar',
    scope: 'calendar',
    beta: false,
    icon: 'logomark.calendar',
    background: token('--t-fill-color-product-calendar-050'),
  },
  {
    name: 'Check-Ins',
    key: 'check-ins',
    scope: 'check_ins',
    beta: false,
    icon: 'logomark.checkIns',
    background: token('--t-fill-color-product-checkins-050'),
    color: '#ffffff',
  },
  {
    name: 'Current',
    key: 'current',
    scope: null,
    beta: false,
    icon: 'logomark.api',
    background: colors['api'],
  },
  {
    name: 'Giving',
    key: 'giving',
    scope: 'giving',
    beta: false,
    icon: 'logomark.giving',
    background: token('--t-fill-color-product-giving-050'),
  },
  {
    name: 'Groups',
    key: 'groups',
    scope: 'groups',
    beta: false,
    icon: 'logomark.groups',
    background: token('--t-fill-color-product-groups-050'),
    color: '#ffffff',
  },
  {
    name: 'People',
    key: 'people',
    scope: 'people',
    beta: false,
    icon: 'logomark.people',
    background: token('--t-fill-color-product-people-050'),
    color: '#ffffff',
  },
  {
    name: 'Publishing',
    key: 'publishing',
    scope: 'publishing',
    beta: false,
    icon: 'logomark.publishing',
    background: token('--t-fill-color-product-publishing-050'),
    color: '#ffffff',
  },
  {
    name: 'Registrations',
    key: 'registrations',
    scope: 'registrations',
    beta: false,
    icon: 'logomark.registrations',
    background: token('--t-fill-color-product-registrations-050'),
    color: '#ffffff',
  },
  {
    name: 'Services',
    key: 'services',
    scope: 'services',
    beta: false,
    icon: 'logomark.services',
    background: token('--t-fill-color-product-services-050'),
    color: '#ffffff',
  },
  {
    name: 'Webhooks',
    key: 'webhooks',
    scope: null,
    beta: false,
    icon: 'api.webhook',
    background: colors['webhooks'],
    color: '#ffffff',
  },
]

export default Apps
